import { render, staticRenderFns } from "./RadixSuspensionRequests.vue?vue&type=template&id=79e49403&"
import script from "./RadixSuspensionRequests.vue?vue&type=script&lang=js&"
export * from "./RadixSuspensionRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports